/**
 * neccst-legal-toc.js
 * Builds the contents rail for long legal documents.
 *
 * Behaviour:
 *  - Queries all h2 and h3 inside #legal-body.
 *  - If the total word count of the document is above the threshold (approx
 *    1000 words), renders a numbered TOC into #legal-toc, adds the `has-toc`
 *    class to #legal-layout, and removes the `hidden` attribute from the rail.
 *  - Highlights the active section as the user scrolls (IntersectionObserver).
 *  - Gracefully no-ops when the elements are absent (short docs, or a page
 *    where the section is not loaded).
 */
(function () {
  'use strict';

  var WORD_THRESHOLD = 1000;
  var SCROLL_MARGIN  = 120; // px offset from viewport top when anchor-scrolling

  function init() {
    var body   = document.getElementById('legal-body');
    var toc    = document.getElementById('legal-toc');
    var layout = document.getElementById('legal-layout');
    if (!body || !toc || !layout) return;

    // Count words in the body text
    var wordCount = (body.innerText || body.textContent || '').trim().split(/\s+/).length;
    if (wordCount < WORD_THRESHOLD) return;

    // Collect headings
    var headings = Array.prototype.slice.call(body.querySelectorAll('h2, h3'));
    if (headings.length < 2) return;

    // Ensure each heading has an id for anchor links
    headings.forEach(function (h, i) {
      if (!h.id) {
        h.id = 'legal-section-' + (i + 1);
      }
      h.style.scrollMarginTop = SCROLL_MARGIN + 'px';
    });

    // Build TOC markup
    var label = document.createElement('h2');
    label.textContent = 'Contents';
    toc.appendChild(label);

    var ol = document.createElement('ol');
    headings.forEach(function (h) {
      var li = document.createElement('li');
      var a  = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      if (h.tagName === 'H3') a.classList.add('toc-h3');
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById(h.id);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
      li.appendChild(a);
      ol.appendChild(li);
    });
    toc.appendChild(ol);

    // Show the TOC rail
    toc.removeAttribute('hidden');
    layout.classList.add('has-toc');

    // Intersection observer for active-link highlighting
    if (!window.IntersectionObserver) return;

    var tocLinks = Array.prototype.slice.call(toc.querySelectorAll('a'));
    var activeId = null;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          activeId = entry.target.id;
        }
      });
      updateActive();
    }, {
      rootMargin: '-' + SCROLL_MARGIN + 'px 0px -60% 0px',
      threshold: 0
    });

    headings.forEach(function (h) { observer.observe(h); });

    function updateActive() {
      tocLinks.forEach(function (a) {
        if (a.getAttribute('href') === '#' + activeId) {
          a.classList.add('toc-active');
        } else {
          a.classList.remove('toc-active');
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
